import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-helpbutton-reports-assistanceaveragetimemillis-card',
  templateUrl: './helpbutton-reports-assistanceaveragetimemillis-card.component.html',
  styleUrls: ['./helpbutton-reports-assistanceaveragetimemillis-card.component.scss']
})
export class HelpbuttonReportsAssistanceaveragetimemillisCardComponent implements OnInit {

  @Input() value;

  constructor() { }

  ngOnInit() {
  }

}
